export default __webpack_public_path__ + "static/media/QSM3Info.6007072b.md";